import Vue from 'vue'
import Vuex from 'vuex'
import MessageStore from './message'
import ChatStore from './store_chat'
import StoreStore from './stores'
Vue.use(Vuex)

console.log(`current update: sort products by index`)

export default new Vuex.Store({
  modules: {
    message: MessageStore,
    chatStore: ChatStore,
    stores: StoreStore
  }
})
